<template>
  <div>
    <div class="sidebar-container" v-if="permits.items && permits.items.length > 0">
      <template v-for="permit in permits.items">
        <router-link
          :key="permit.id"
          :to="isMobileScreen ? {name: 'edit-user-permit', params: { id: permit.id }} : { name: 'user-permit', params: { id: permit.id } }"
          class="permit-block"
          v-show="isPermitExpired(permit) ? checkedHidePermits!==true : true"
          :class="{'permit-block--active': editingId === permit.id, 'active': activePermit === permit.id}">
          <div :class="{ 'permit-header': isDuplicatedPermit(permit) }" style="height: 100%">
            <div class="permit-block__zone" style="height: 100%">
              <div class="permit-block__product" v-if="permit.productName">
                <span class="icon-product"></span>
                <span>{{ permit.productName }}</span>
              </div>
              <div v-if="permit.address">
                <span class="fa fa-map-marker icon-zone"></span>
                <span>{{ permit.address }}</span>
              </div>
            </div>
            <div class="icon-container" v-if="isDuplicatedPermit(permit)">
              <div class="permit-icon-container"><img src="~assets/duplicate-permit.svg"/></div>
            </div>
          </div>
          <div class="permit-block__identifiers"
               :class="{'smaller-font': permit.vehicleReg && permit.vehicleReg.length > 6 || (permit.vehicleReg && permit.parkingCardNr)}">
            <div class="permit-block__identifiers__identity"
                 :class="{
                    'active': isEditingManually && editingId === permit.id,
                    'smaller-font': permit.vehicleReg && permit.vehicleReg.length > 6 || (permit.vehicleReg && permit.parkingCardNr)
                  }"
                 v-if="permit.vehicleReg">
              <div class="permit-plate-container">
                <div class="permit-plate" :style="!permit.parkingSpotNumber ? 'padding-bottom: 10px;' : ''">
                  <div
                    class="icon car-icon"
                    :class="isEditingManually && editingId === permit.id ? 'icon-car-grey' : 'icon-car-white'">
                  </div>
                  <p
                    v-if="!isEditingManually || editingId !== permit.id"
                    class="permit-plate-number"
                  >{{ permit.vehicleReg }}</p>

                  <input
                    v-if="isEditingManually && editingId === permit.id"
                    v-model="editValue"
                    class="edit-input"
                    :ref="'input-' + permit.id"
                    @keyup.enter="savePlateNr()"
                    @click.prevent
                  />
                </div>
                <div v-if="permit.parkingSpotNumber && (!isEditingManually || editingId !== permit.id)"
                     class="permit-spot-number">
                  <span class="permit-plate__spot"></span>
                  <span>{{ permit.parkingSpotNumber }}</span>
                </div>
              </div>
              <div v-if="!isEditingManually || editingId !== permit.id" class="plate-action edit-icon"
                   @click.prevent="startEditPlateNr(permit)">
                <div class="icon-square icon-edit-square"/>
              </div>
              <div v-else class="plate-action save-icon" @click.prevent="savePlateNr()">
                <div class="icon-square icon-done-black"/>
              </div>
            </div>
            <div class="parking-card-container" v-if="permit.parkingCardNr" @click.prevent="zoomCard(permit.id)">
              <div class="permit-block__identifiers__identity permit-card permit-card__small"
                   :class="{'permit-card--zoomed': isCardZoomed && zoomedCardId === permit.id}">
                <div class="permit-card__number">{{ permit.parkingCardNr }}</div>
              </div>
              <div class="card-magnifier icon-zoom"></div>
            </div>
            <div
              class="permit-block__identifiers__identity no-identity"
              v-if="!permit.vehicleReg && !permit.parkingCardNr"
            >
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              {{ $t('end_user.permit_needs_identity') }}
            </div>
            <div v-if="!isMobileScreen" class="permit-block__identifiers__edit"
                 @click.prevent="showListModalVehicle(permit)">
              <div class="icon-more"></div>
            </div>

            <router-link
              v-else
              :to="{name: 'edit-user-permit', params: { id: permit.id }}"
              :key="permit.id"
              v-show="isMobileScreen && isPermitExpired(permit) ? checkedHidePermits !== true : true"
            >
              <div class="permit-block__identifiers__edit" v-if="permit.vehicleReg">
                <div class="icon-more"></div>
              </div>
            </router-link>

          </div>
          <div
            class="permit-card-validity"
            v-if="!isPermitExpired(permit) && permitValidityPeriod(permit).length > 0"
          >{{ permitValidityPeriod(permit) }}
          </div>
          <div
            class="permit-card-expired"
            v-if="isPermitExpired(permit)"
          >{{ $t('end_user.permit_expired', { expirationDate: permit.expirationDate }) }}
          </div>
          <div
            v-if="permit.validFromDate && !permit.expirationDate && !permit.permitUpdatedAt"
            class="permit-block__updatedat"
          >{{ $t('end_user.permit_validity_from', { from: permit.validFromDate }) }}
          </div>
          <div
            v-if="permit.permitUpdatedAt && !permit.expirationDate"
            class="permit-block__updatedat"
          >{{ $t('end_user.vehicle_updated_at', { from: permit.permitUpdatedAt }) }}
          </div>
        </router-link>
      </template>
      <VehicleSelectionModal
        :show="showListModal"
        :user-id="user.data.selectedRole.id"
        :active-vehicle-id="activePlate"
        @close="closeListModal"
        @confirmed="confirmedListModal"
        v-if="user.data"
      />
    </div>
    <div class="no-permits" v-if="(!permits.items || permits.items.length === 0)">
      <h1>{{ $t('end_user.no_permits') }}</h1>
    </div>
    <WarningModal v-if="showWarningModal" @close="showWarningModal = false">
      <h1 slot="header">{{ $t('common.warning') }}</h1>
      <p slot="body">{{ plateErrorMessage }}</p>
    </WarningModal>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment';
import { mapGetters } from 'vuex';
import WarningModal from '../common/WarningModal.vue';
import VehicleSelectionModal from '../common/VehicleSelectionModal.vue';

export default {
  components: { WarningModal, VehicleSelectionModal },
  data() {
    return {
      activePermit: null,
      isMobileScreen: false,
      editingId: null,
      initialEditValue: '',
      editValue: '',
      showWarningModal: false,
      isCardZoomed: false,
      zoomedCardId: '',
      showListModal: false,
      activePlate: null,
      isEditingManually: false,
    };
  },
  props: {
    checkedHidePermits: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      permits: 'landlord/permits/permits',
      error: 'permits/permit/error',
      user: 'user/user/user',
    }),
    plateErrorMessage() {
      const message = this.error && this.error.body ? this.error.body.message : null;
      if (message && this.$te(`errors.${message}`)) {
        return this.$t(`errors.${message}`);
      }
      return 'Error changing vehicle registration number';
    },
  },
  watch: {
    $route: 'selectPermit',
  },
  created() {
    this.selectPermit();
    window.addEventListener('resize', this.setIsMobileScreen);
    this.setIsMobileScreen();
  },
  methods: {
    showListModalVehicle(permit) {
      this.activePlate = permit.vehicleId;
      this.initialEditValue = permit.vehicleReg;
      this.editingId = permit.id;
      this.showListModal = true;
    },
    closeListModal() {
      this.showListModal = false;
    },
    confirmedListModal(selectedVehicle) {
      if (!selectedVehicle || !selectedVehicle.id) {
        this.showListModal = false;
        return;
      }
      this.editValue = selectedVehicle.vehicle_reg;
      this.savePlateNr(selectedVehicle.id, selectedVehicle.comment);
      this.activePlate = selectedVehicle.id;
      this.showListModal = false;
    },
    selectPermit() {
      if (this.$route.params.id) {
        this.activePermit = parseInt(this.$route.params.id, 10);
      }
    },
    zoomCard(permitId) {
      if (this.isCardZoomed && this.zoomedCardId === permitId) {
        this.isCardZoomed = false;
        this.zoomedCardId = '';
      } else {
        this.isCardZoomed = true;
        this.zoomedCardId = permitId;
      }
    },
    startEditPlateNr(permit) {
      this.initialEditValue = permit.vehicleReg;
      this.editingId = permit.id;
      this.editValue = permit.vehicleReg; // make a working copy
      this.isEditingManually = true;
      this.$nextTick(() => {
        const el = this.$refs['input-' + permit.id][0];
        el.focus();
      });
    },
    savePlateNr(vehicleId = null, vehicleComment = null) {
      if (!this.editValue || this.initialEditValue === this.editValue.trim()) {
        this.editingId = null;
        this.editValue = '';
        this.isEditingManually = false;
        return;
      }
      this.$store.dispatch('permits/permit/updatePermitVehicleReg', {
        permitId: this.editingId,
        vehicleReg: this.editValue,
        comment: vehicleComment,
        user: this.user,
      }).then(() => {
        if (this.error) {
          this.showWarningModal = true;
          return;
        }
        const item = this.permits.items.find(p => p.id === this.editingId);
        if (item) {
          item.vehicleReg = this.editValue.trim().toUpperCase();
           if (vehicleId) {
            item.vehicleId = vehicleId;
          }
        }

        if (this.activePermit === this.editingId) {
          this.$store.dispatch('permits/permit/fetch', { id: this.activePermit, user: this.user });
        }

        this.editingId = null;
        this.editValue = '';
        this.activePlate = null;
        this.isEditingManually = false;
      });
    },
    isDuplicatedPermit(permitToSearch) {
      const filteredPermits = this.permits.items.filter(permit => permit.vehicleReg === permitToSearch.vehicleReg && permit.productName === permitToSearch.productName);
      return filteredPermits.length > 1;
    },
    setIsMobileScreen() {
      if (window.innerWidth > 760) {
        this.isMobileScreen = false;
      } else {
        this.isMobileScreen = true;
      }
    },
    permitValidityPeriod(permit) {
      if (permit.validFromDate && permit.expirationDate) {
        return this.$t('end_user.permit_validity', { from: permit.validFromDate, to: permit.expirationDate });
      }
      return '';
    },
    isPermitExpired(permit) {
      if (!permit.expirationDate) {
        return false;
      }

      return moment().isAfter(moment(permit.expirationDate, 'DD.MM.YYYY'), 'day');
    },
    formatDate(momentDate) {
      return moment(momentDate, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
    },
    stopInputAtDashAndSpace(event) {
      if (event.key === '-' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
  },
};
</script>

<style media="screen" scoped lang="scss">
@import "~styles/app.scss";
@import "~styles/_animations.scss";
@import "~styles/blocks/permit.scss";

.permit-header {
  display: flex;
  gap: 8px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #00d1b2;
  border-radius: 5px;
  flex-basis: 15%;
}

.permit-icon-container {
  display: flex;
}

.no-permits {
  background: var(--brand-red);
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  color: var(--white);
  padding: 20px;
  flex-direction: column;

  @media screen and (max-width: 1115px) {
    margin: 0 0 45px 0;
  }
}

.sidebar-container {
  height: 100%;
  display: inline-block;
  margin-right: -20px;

  @media screen and (max-width: 520px) {
    width: 100%;
  }

  @media screen and (max-width: 760px) {
    width: 100%;
  }

  .permit-block {
    margin: 0 20px 10px 0;

    &.active {
      @media screen and (min-width: 760px) {
        width: 320px;
        margin-right: 0;
        padding-right: 20px;
      }
    }
  }
}

.icon-zone {
  margin: 0 5px 0 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/Sidebar.vue